export const categories = [
  { id: 'dianshiju', name: '电视剧', slug: 'dianshiju', icon: 'ri-tv-line', description: '最新电视剧更新，同步各大平台热门剧集' },
  { id: 'dianying', name: '电影', slug: 'dianying', icon: 'ri-film-line', description: '最新电影上映，院线大片一网打尽' },
  { id: 'zongyi', name: '综艺', slug: 'zongyi', icon: 'ri-live-line', description: '最新综艺在线，热门综艺抢先看' },
  { id: 'dongman', name: '动漫', slug: 'dongman', icon: 'ri-ghost-line', description: '热门动漫连载，日漫国漫全覆盖' },
  { id: 'jilupian', name: '纪录片', slug: 'jilupian', icon: 'ri-slideshow-line', description: '高分纪录片，探索世界奥秘' },
];

export const heroSlides = [
  {
    id: 1,
    title: '梦华录',
    subtitle: '古装传奇大戏 · 刘亦菲陈晓领衔主演',
    description: '繁华汴京城，一段跨越阶层的爱恨纠葛。三位女性的成长蜕变，在商海中书写属于自己的传奇故事。豆瓣8.5分口碑佳作，全网播放量破百亿。',
    category: '电视剧',
    rating: '8.5',
    badge: '热播中',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20with%20dramatic%20lighting%2C%20rich%20warm%20golden%20and%20deep%20red%20tones%2C%20film%20grain%20texture%2C%20atmospheric%20Chinese%20cinema%20aesthetic%2C%20artistic%20composition%20with%20soft%20bokeh%20background%2C%20luxurious%20deep%20color%20grading&width=1600&height=900&seq=hero-slide-1&orientation=landscape',
    link: '/article/1',
  },
  {
    id: 2,
    title: '流浪地球3',
    subtitle: '科幻巨制 · 吴京刘德华震撼回归',
    description: '人类命运共同体的终极篇章！太阳危机再度升级，全球联合政府启动「移山计划」最终阶段。IMAX特效全面升级，暑期档必看大片。',
    category: '电影',
    rating: '9.1',
    badge: '即将上映',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cinematic%20scene%20with%20dramatic%20space%20lighting%2C%20deep%20blue-black%20cosmos%2C%20warm%20orange%20planet%20glow%2C%20epic%20scale%20composition%2C%20film%20grain%20texture%2C%20atmospheric%20Chinese%20sci-fi%20movie%20aesthetic&width=1600&height=900&seq=hero-slide-2&orientation=landscape',
    link: '/article/2',
  },
  {
    id: 3,
    title: '奔跑吧第八季',
    subtitle: '国民综艺王者归来 · 全新阵容爆笑升级',
    description: '跑男团再出发！全新游戏环节设计，笑点密集不间断。每周五晚锁定久久影视，与跑男团一起欢乐出发。',
    category: '综艺',
    rating: '7.9',
    badge: '热播中',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20outdoor%20variety%20show%20scene%20with%20bright%20sunny%20day%2C%20colorful%20playful%20atmosphere%2C%20group%20of%20people%20laughing%20and%20playing%20games%2C%20dynamic%20composition%2C%20energetic%20Chinese%20TV%20show%20aesthetic&width=1600&height=900&seq=hero-slide-3&orientation=landscape',
    link: '/article/3',
  },
];

export interface Article {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  rating: string;
  badge?: string;
  description: string;
  imageUrl: string;
  date: string;
  views: string;
  tags: string[];
  detail?: {
    director: string;
    actors: string[];
    year: string;
    region: string;
    episodes?: string;
    duration?: string;
    content: string;
    highlights: string[];
  };
}

export const featuredArticles: Article[] = [
  {
    id: 1,
    title: '梦华录',
    category: '电视剧',
    categorySlug: 'dianshiju',
    rating: '8.5',
    badge: '热播中',
    description: '繁华汴京城，三段女性在逆境中相互扶持、共同成长的动人故事。刘亦菲、陈晓、柳岩、林允主演，古装商战与爱情交织。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20scene%20with%20elegant%20costumes%2C%20warm%20candlelight%2C%20rich%20golden%20and%20crimson%20color%20palette%2C%20traditional%20architecture%20background%2C%20cinematic%20composition%20with%20soft%20diffused%20lighting&width=800&height=450&seq=featured-1&orientation=landscape',
    date: '2026-07-28',
    views: '128.5万',
    tags: ['古装', '爱情', '商战', '女性成长'],
    detail: {
      director: '杨阳',
      actors: ['刘亦菲', '陈晓', '柳岩', '林允'],
      year: '2025',
      region: '中国大陆',
      episodes: '40集',
      content: '《梦华录》讲述了赵盼儿、宋引章、孙三娘三位女性在北宋汴京城中，凭借自己的智慧和勇气，从社会底层一步步开创事业、收获爱情的故事。该剧以北宋商业繁荣为背景，展现了古代女性的独立精神与坚韧品格，同时也描绘了一幅生动的汴京市井画卷。',
      highlights: ['豆瓣8.5分口碑力作', '全网播放量突破百亿', '刘亦菲时隔16年回归电视剧', '荣获金鹰奖最佳电视剧'],
    },
  },
  {
    id: 2,
    title: '流浪地球3',
    category: '电影',
    categorySlug: 'dianying',
    rating: '9.1',
    badge: '即将上映',
    description: '太阳危机终极之战！人类命运共同体的最后篇章。吴京、刘德华、李雪健领衔主演。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20massive%20spacecraft%2C%20dramatic%20orange%20and%20blue%20lighting%20contrast%2C%20futuristic%20technology%2C%20grand%20scale%20composition%2C%20cinematic%20depth%20of%20field%2C%20atmospheric%20dust%20particles&width=800&height=450&seq=featured-2&orientation=landscape',
    date: '2026-08-15',
    views: '356.2万',
    tags: ['科幻', '灾难', '吴京', 'IMAX'],
    detail: {
      director: '郭帆',
      actors: ['吴京', '刘德华', '李雪健', '沙溢'],
      year: '2026',
      region: '中国大陆',
      duration: '148分钟',
      content: '《流浪地球3》作为流浪地球系列的终章，延续了前作宏大的世界观设定。太阳危机进入不可逆阶段，地球联合政府启动了「移山计划」的最终阶段。人类必须在有限的时间内完成不可能的挑战，这是关乎全人类存亡的终极之战。',
      highlights: ['IMAX特制拍摄', '国产科幻巅峰之作', '全球同步上映', '特效镜头超过前作总和'],
    },
  },
  {
    id: 3,
    title: '奔跑吧第八季',
    category: '综艺',
    categorySlug: 'zongyi',
    rating: '7.9',
    badge: '热播中',
    description: '国民综艺再度回归！全新阵容全新玩法，每期带给你不一样的欢乐体验。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20outdoor%20variety%20show%20setting%20with%20colorful%20decorations%2C%20group%20of%20celebrities%20in%20casual%20sportswear%2C%20sunny%20park%20background%2C%20energetic%20and%20playful%20mood%2C%20dynamic%20wide%20angle%20composition&width=800&height=450&seq=featured-3&orientation=landscape',
    date: '2026-07-15',
    views: '89.3万',
    tags: ['真人秀', '竞技', '搞笑', '户外'],
    detail: {
      director: '姚译添',
      actors: ['李晨', '郑恺', '沙溢', '白鹿', '周深', '范丞丞'],
      year: '2026',
      region: '中国大陆',
      episodes: '12期',
      content: '《奔跑吧》第八季延续了往季节目的核心玩法，同时引入了全新的游戏机制和挑战环节。本季跑男团将踏上全新的旅程，足迹遍布全国各地，在竞技中传递欢乐与正能量。每期节目都有特邀嘉宾加盟，带来更多惊喜。',
      highlights: ['全新游戏环节设计', '豪华嘉宾阵容', '多地实景拍摄', '互动感全面升级'],
    },
  },
  {
    id: 4,
    title: '长安十二时辰',
    category: '电视剧',
    categorySlug: 'dianshiju',
    rating: '8.8',
    badge: '经典回顾',
    description: '大唐天宝三年，上元节前夕，长安城陷入一场惊天阴谋。雷佳音、易烊千玺主演。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tang%20Dynasty%20ancient%20Chinese%20city%20at%20night%20with%20lanterns%2C%20suspenseful%20atmosphere%2C%20traditional%20architecture%2C%20warm%20amber%20lighting%2C%20mysterious%20shadows%2C%20cinematic%20thriller%20mood&width=800&height=450&seq=featured-4&orientation=landscape',
    date: '2026-06-20',
    views: '56.8万',
    tags: ['古装', '悬疑', '历史', '马伯庸'],
    detail: {
      director: '曹盾',
      actors: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
      year: '2019',
      region: '中国大陆',
      episodes: '48集',
      content: '《长安十二时辰》改编自马伯庸同名小说，讲述了唐朝天宝三载上元节前夕，长安城陷入一场惊天阴谋，死囚张小敬临危受命，与靖安司司丞李必携手在十二时辰内拯救长安的故事。该剧以其精良的制作和对大唐盛世的真实还原获得了广泛赞誉。',
      highlights: ['豆瓣8.8分神作', '服化道考究精良', '高度还原大唐风貌', '悬疑节奏紧凑'],
    },
  },
  {
    id: 5,
    title: '封神第二部',
    category: '电影',
    categorySlug: 'dianying',
    rating: '8.3',
    badge: '热映中',
    description: '神话史诗巨制续作！殷商大战全面爆发，姜子牙率众神迎战。费翔、黄渤、于适主演。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20battle%20scene%20with%20ancient%20warriors%2C%20dramatic%20stormy%20sky%2C%20golden%20armor%2C%20grand%20scale%20fantasy%20composition%2C%20cinematic%20epic%20lighting%20with%20warm%20earth%20tones&width=800&height=450&seq=featured-5&orientation=landscape',
    date: '2026-07-01',
    views: '245.7万',
    tags: ['神话', '史诗', '奇幻', '封神'],
    detail: {
      director: '乌尔善',
      actors: ['费翔', '黄渤', '于适', '陈牧驰'],
      year: '2026',
      region: '中国大陆',
      duration: '156分钟',
      content: '《封神第二部》承接第一部剧情，殷商与西岐之间的大战全面爆发。姜子牙率领各路神仙加入战场，封神榜上的名字一个接一个被刻下。本片在视觉效果和动作场面上全面升级，呈现了中国神话史诗的宏大格局。',
      highlights: ['神话史诗视觉盛宴', '演员阵容豪华', '特效制作精良', '票房口碑双丰收'],
    },
  },
  {
    id: 6,
    title: '乘风破浪的姐姐第五季',
    category: '综艺',
    categorySlug: 'zongyi',
    rating: '8.1',
    badge: '热播中',
    description: '30+姐姐再度集结！舞台竞技、真情流露，展现成熟女性的无限魅力。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Glamorous%20stage%20performance%20with%20spotlights%2C%20elegant%20women%20in%20stunning%20dresses%2C%20dramatic%20theater%20lighting%2C%20warm%20pink%20and%20gold%20color%20scheme%2C%20musical%20performance%20atmosphere&width=800&height=450&seq=featured-6&orientation=landscape',
    date: '2026-07-10',
    views: '178.4万',
    tags: ['音乐', '竞技', '女性', '舞台'],
    detail: {
      director: '晏吉',
      actors: ['宁静', '那英', '王心凌', 'Jessica'],
      year: '2026',
      region: '中国大陆',
      episodes: '12期',
      content: '《乘风破浪的姐姐》第五季延续了节目的核心精神——30岁以上的女艺人打破年龄界限，在舞台上重新绽放光彩。本季赛制全新升级，舞台设计更加惊艳，姐姐们的表现也更加精彩。',
      highlights: ['赛制全新升级', '舞台视觉震撼', '姐姐们真情演绎', '话题度持续爆棚'],
    },
  },
];

export const trendingList: Article[] = [
  {
    id: 7, title: '庆余年第二季', category: '电视剧', categorySlug: 'dianshiju', rating: '8.7', badge: '热播中',
    description: '范闲归来！权谋与江湖交织的精彩续作', imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20intrigue%20drama%20scene%20with%20scholarly%20protagonist%2C%20warm%20golden%20lighting%2C%20traditional%20architecture%2C%20suspenseful%20atmosphere%2C%20rich%20period%20costumes&width=400&height=280&seq=trending-1&orientation=landscape',
    date: '2026-07-25', views: '567.3万', tags: ['古装', '权谋', '张若昀'],
  },
  {
    id: 8, title: '哪吒之魔童闹海', category: '电影', categorySlug: 'dianying', rating: '9.3', badge: '票房冠军',
    description: '国产动画新高峰，票房超50亿的现象级作品', imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20scene%20with%20mythological%20character%2C%20vibrant%20fire%20and%20water%20effects%2C%20dramatic%20red%20and%20gold%20color%20palette%2C%20epic%20fantasy%20composition&width=400&height=280&seq=trending-2&orientation=landscape',
    date: '2026-07-20', views: '892.1万', tags: ['动画', '神话', '奇幻', '国产'],
  },
  {
    id: 9, title: '狂飙', category: '电视剧', categorySlug: 'dianshiju', rating: '9.0', badge: '口碑神作',
    description: '扫黑除恶题材巅峰之作，张译张颂文飙戏', imageUrl: 'https://readdy.ai/api/search-image?query=Gritty%20crime%20drama%20scene%20with%20two%20men%20in%20tense%20confrontation%2C%20dark%20moody%20lighting%2C%20urban%20Chinese%20setting%2C%20suspenseful%20atmosphere%2C%20film%20noir%20style&width=400&height=280&seq=trending-3&orientation=landscape',
    date: '2026-06-15', views: '1023.6万', tags: ['悬疑', '犯罪', '扫黑除恶'],
  },
  {
    id: 10, title: '王牌对王牌第九季', category: '综艺', categorySlug: 'zongyi', rating: '7.6', badge: '热播中',
    description: '经典游戏+全新挑战，笑点不断温情满满', imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20TV%20studio%20game%20show%20set%20with%20bright%20lights%2C%20celebrities%20laughing%20and%20playing%20games%2C%20vibrant%20stage%20design%2C%20entertaining%20atmosphere&width=400&height=280&seq=trending-4&orientation=landscape',
    date: '2026-07-18', views: '134.8万', tags: ['游戏', '搞笑', '竞技'],
  },
  {
    id: 11, title: '三体', category: '电视剧', categorySlug: 'dianshiju', rating: '8.9', badge: '科幻巨制',
    description: '刘慈欣科幻巨著改编，国产科幻剧集新标杆', imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20sci-fi%20scene%20with%20cosmic%20elements%2C%20deep%20space%20background%2C%20intellectual%20atmosphere%2C%20cool%20silver%20and%20dark%20blue%20tones%2C%20mind-bending%20visual%20style&width=400&height=280&seq=trending-5&orientation=landscape',
    date: '2026-07-05', views: '456.9万', tags: ['科幻', '刘慈欣', '悬疑'],
  },
];

export const newReleases: Article[] = [
  {
    id: 12, title: '繁花', category: '电视剧', categorySlug: 'dianshiju', rating: '8.6', badge: '新剧推荐',
    description: '王家卫首部电视剧，胡歌马伊琍演绎上海滩风云', imageUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%201990s%20Shanghai%20street%20scene%20with%20neon%20lights%2C%20elegant%20vintage%20fashion%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20Wong%20Kar-wai%20aesthetic%2C%20romantic%20atmosphere&width=400&height=280&seq=new-1&orientation=landscape',
    date: '2026-07-30', views: '78.2万', tags: ['年代', '商战', '上海', '王家卫'],
  },
  {
    id: 13, title: '熊出没·重启未来', category: '电影', categorySlug: 'dianying', rating: '8.0', badge: '新片上线',
    description: '熊大熊二光头强再度出发，科幻冒险合家欢', imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20forest%20adventure%20scene%20with%20friendly%20bear%20characters%2C%20bright%20sunny%20day%2C%20playful%20mood%2C%20family-friendly%20animation%20style%2C%20vibrant%20greens%20and%20blues&width=400&height=280&seq=new-2&orientation=landscape',
    date: '2026-07-29', views: '45.6万', tags: ['动画', '冒险', '合家欢'],
  },
  {
    id: 14, title: '脱口秀大会第七季', category: '综艺', categorySlug: 'zongyi', rating: '7.5', badge: '新季开播',
    description: '全新赛制全新段子，笑到停不下来的脱口秀盛宴', imageUrl: 'https://readdy.ai/api/search-image?query=Stand-up%20comedy%20stage%20with%20spotlight%20on%20performer%2C%20warm%20theater%20lighting%2C%20microphone%20on%20stand%2C%20intimate%20club%20atmosphere%2C%20brick%20wall%20background&width=400&height=280&seq=new-3&orientation=landscape',
    date: '2026-07-28', views: '67.9万', tags: ['脱口秀', '喜剧', '语言'],
  },
  {
    id: 15, title: '大奉打更人', category: '电视剧', categorySlug: 'dianshiju', rating: '8.2', badge: '新剧热播',
    description: '王鹤棣田曦薇主演，仙侠探案两不误的爽剧佳作', imageUrl: 'https://readdy.ai/api/search-image?query=Fantasy%20Chinese%20martial%20arts%20drama%20scene%20with%20flowing%20robes%2C%20misty%20mountain%20background%2C%20elegant%20swordsman%2C%20ethereal%20lighting%2C%20traditional%20Chinese%20ink%20painting%20aesthetic&width=400&height=280&seq=new-4&orientation=landscape',
    date: '2026-07-27', views: '198.3万', tags: ['仙侠', '探案', '古装', '王鹤棣'],
  },
  {
    id: 16, title: '默杀', category: '电影', categorySlug: 'dianying', rating: '7.8', badge: '悬疑推荐',
    description: '校园霸凌题材悬疑片，反转不断扣人心弦', imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20suspenseful%20school%20corridor%20scene%2C%20moody%20lighting%20with%20long%20shadows%2C%20mysterious%20atmosphere%2C%20thriller%20film%20aesthetic%2C%20cold%20blue-gray%20color%20tones&width=400&height=280&seq=new-5&orientation=landscape',
    date: '2026-07-26', views: '112.5万', tags: ['悬疑', '犯罪', '校园'],
  },
  {
    id: 17, title: '一年一度喜剧大赛第四季', category: '综艺', categorySlug: 'zongyi', rating: '8.4', badge: '口碑综艺',
    description: '新喜剧人集结！素描喜剧、漫才、音乐剧轮番登场', imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20comedy%20theater%20stage%20with%20performers%20in%20funny%20costumes%2C%20bright%20stage%20lights%2C%20cheerful%20audience%2C%20lively%20entertainment%20atmosphere%2C%20dynamic%20performance&width=400&height=280&seq=new-6&orientation=landscape',
    date: '2026-07-25', views: '89.1万', tags: ['喜剧', '竞技', '素描喜剧'],
  },
  {
    id: 18, title: '清明上河图密码', category: '电视剧', categorySlug: 'dianshiju', rating: '8.3', badge: '悬疑大剧',
    description: '张颂文白百何主演，北宋奇案层层揭秘', imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20scroll%20painting%20style%20scene%20with%20Song%20Dynasty%20street%20life%2C%20warm%20sepia%20tones%2C%20detailed%20architecture%2C%20mysterious%20atmosphere%2C%20traditional%20ink%20painting%20aesthetic&width=400&height=280&seq=new-7&orientation=landscape',
    date: '2026-07-24', views: '156.7万', tags: ['悬疑', '古装', '张颂文', '探案'],
  },
  {
    id: 19, title: '异人之下2', category: '电影', categorySlug: 'dianying', rating: '7.9', badge: '漫改大片',
    description: '国漫顶级IP改编，异能世界的热血冒险再启程', imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20supernatural%20action%20scene%20with%20energy%20effects%2C%20urban%20Chinese%20city%20background%2C%20martial%20arts%20pose%2C%20vibrant%20color%20bursts%2C%20comic-book%20style%20visual%20aesthetic&width=400&height=280&seq=new-8&orientation=landscape',
    date: '2026-07-23', views: '203.4万', tags: ['奇幻', '动作', '漫改'],
  },
];

export const faqData = [
  {
    question: '久久影视需要注册会员才能观看吗？',
    answer: '久久影视是一个影视资讯聚合平台，我们提供最新电视剧更新、最新电影上映的信息和导航。部分内容可免费浏览，注册会员后可享受更多个性化推荐和观影记录同步等高级功能。',
  },
  {
    question: '久久影视的影视更新速度快吗？',
    answer: '我们的影视更新速度非常快！久久影视同步最新电视剧更新与最新电影上映，通常在各大平台更新后的第一时间同步信息。新剧综艺抢先看，让您不错过任何精彩内容。',
  },
  {
    question: '久久影视支持哪些设备观看？',
    answer: '久久影视支持全平台访问，包括PC端网页、手机浏览器、平板电脑等。我们采用自适应设计，无论您使用什么设备，都能获得高清流畅不缓冲的观影体验。推荐使用Chrome或Safari浏览器访问。',
  },
  {
    question: '久久影视的视频画质如何？',
    answer: '久久影视致力于提供高清流畅的观影体验，大部分内容支持1080P高清画质，部分热门影视作品更提供4K超清选项。我们采用先进的视频编码和CDN加速技术，让追剧不再卡顿。',
  },
  {
    question: '如何获取久久影视的最新影视动态？',
    answer: '您可以关注久久影视官网首页的「最新更新」板块，也可以通过订阅我们的邮件通知或关注官方社交媒体账号来获取最新影视动态。我们将每日更新最新剧集和新片在线的信息。',
  },
  {
    question: '久久影视有移动端APP吗？',
    answer: '久久影视移动端APP正在紧锣密鼓地开发中，届时将提供iOS和Android双平台版本。目前您可以通过手机浏览器访问久久影视官网，同样可以获得流畅的移动观影体验。敬请期待！',
  },
];

export const aboutInfo = {
  brandName: '久久影视',
  slogan: '同步最新电视剧更新与最新电影上映，影视更新快，新剧抢先看，高清流畅不缓冲',
  introduction: '久久影视成立于2023年，是国内领先的影视资讯聚合平台。我们致力于为追剧爱好者提供最新、最全、最高清的影视内容服务。久久影视汇聚最新电视剧更新、最新电影上映和最新综艺在线资源，让每一位用户都能享受高清不卡的免费追剧体验。',
  story: '久久影视的创立源于创始团队对影视的无限热爱。在信息碎片化时代，观众常常需要在多个平台间切换才能找到想看的影视内容。久久影视应运而生——我们希望通过聚合优质影视资源，让追剧变得更简单、更高效。从最初的几人小团队发展到如今的百人规模，久久影视始终秉持「让好内容触手可及」的初心。',
  values: [
    { title: '内容为王', description: '我们坚信优质内容是一切的基础。久久影视持续追踪最新影视动态，为用户筛选最值得观看的剧集和电影。' },
    { title: '用户体验优先', description: '从页面加载速度到内容推荐算法，久久影视的每一处设计都围绕用户体验展开，确保流畅无阻的观影之旅。' },
    { title: '技术驱动', description: '久久影视采用先进的视频编码和CDN加速技术，保证高清不缓冲的观影体验，让技术为内容服务。' },
    { title: '数据安全', description: '用户隐私和数据安全是久久影视的生命线。我们严格遵守数据保护法规，保护每一位用户的信息安全。' },
  ],
  stats: [
    { label: '月活跃用户', value: '3,800万+' },
    { label: '影视内容库', value: '12万+' },
    { label: '日均更新', value: '500+' },
    { label: '用户好评率', value: '98.6%' },
  ],
  contact: {
    email: 'contact@jiujiuys.com',
    phone: '400-888-9999',
    address: '北京市朝阳区建国路88号SOHO现代城A座12层',
    wechat: '久久影视官方',
    weibo: '@久久影视官方',
    workingHours: '周一至周日 9:00 - 21:00',
  },
};